import { createSelector } from '@ngrx/store';

import { orderTypesImagesState } from '../root';

export const getOrderTypeImage = (orderTypeId: number) =>
    createSelector(orderTypesImagesState, (orderTypesImages) => orderTypesImages.find((image) => image.Id === orderTypeId) || null);
